exports.fluidResuscitationFormulas = {
  parkland: {
    code: 'parkland',
    display: 'Parkland',
  },
  modifiedBrooke: {
    code: 'modifiedBrooke',
    display: 'Modified Brooke',
  },
};